export default __webpack_public_path__ + "static/media/notification.d330cb55.ogg";